var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNodes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8271 13.9746C15.1703 13.9746 13.8271 15.3178 13.8271 16.9746C13.8271 18.6315 15.1703 19.9746 16.8271 19.9746C18.484 19.9746 19.8271 18.6315 19.8271 16.9746C19.8271 15.3178 18.484 13.9746 16.8271 13.9746ZM16.8271 13.9746V6.97461C16.8271 6.44418 16.6164 5.93547 16.2414 5.5604C15.8663 5.18532 15.3576 4.97461 14.8271 4.97461H11.8271M4.82715 7.97461C6.484 7.97461 7.82715 6.63146 7.82715 4.97461C7.82715 3.31776 6.484 1.97461 4.82715 1.97461C3.17029 1.97461 1.82715 3.31776 1.82715 4.97461C1.82715 6.63146 3.17029 7.97461 4.82715 7.97461ZM4.82715 7.97461V19.9746",
    stroke: "#666666",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodes);
export default __webpack_public_path__ + "static/media/nodes.2ce218486fd3f8d859b2d4208b725158.svg";
export { ForwardRef as ReactComponent };